/**
 * Dependencies
 */
import { cloneDeep } from 'lodash'

/**
 * Rental income importer modal state
 *
 * @type {Object}
 */
const state = {
    saveError: null,
    uploading: false,
    uploadProgress: 0,
    showModal: false,
    mapping: {},
    parsed_data: {},
    meta: {},
    error: null,
    fileName: null,
    preview: null,
    saving: false,
    saved: false,
    file_name: null,
    date: null,
    helpRequested: false,
    requestingHelp: false
}
/**

 * Return a fresh copy of the base state
 *
 * @return {Object}
 */
export const getState = () => cloneDeep(state)

export default getState()



// WEBPACK FOOTER //
// ./src/state/modules/rental-income-importer/state.js